export const ARTICLE_BY_ID_ENDPOINT = '/p/v3/kb/articles/:articleId';
export const ARTICLES_SEARCH_ENDPOINT =
  '/p/v3/kb/articles/search?pageSize=100&page=1&term=:term&lang=:lang&knowledgeBaseId=:knowledgeBaseId';
export const KNOWLEDGE_BASE_ARTICLE_RATING_ENDPOINT =
  '/p/v3/kb/articles/:articleId/feedback?lang=:lang';
export const KNOWLEDGE_BASE_ARTICLE_FEEDBACK_ENDPOINT =
  '/p/v3/kb/articles/:articleId/feedback/:id';
